import React, { Component } from 'react';

import { CurrencyIcon } from '../../Assets/Settings/SettingsIcon';

import CurrencyForm from '../../Components/Form/CurrencyForm/CurrencyForm';
import FormLayout from '../../Components/Layout/FormLayout';

class AddCurrency extends Component {
  componentDidMount() {
    document.title = 'Add Currency';
  }

  renderCurrencyForm() {
    return (
      <CurrencyForm
        type="add"
        handleToast={this.props.handleToast}
        closeEditmodal={this.props.closeEditmodal}
        fetchDataWithQueryString={this.props.fetchDataWithQueryString}
        onSubmit={this.props.onSubmit}
        fromInvoice={this.props.fromInvoice}
      />
    );
  }

  render() {
    return <div>{this.renderCurrencyForm()}</div>;
  }
}

export default AddCurrency;
